import { render } from "./MovieList.vue?vue&type=template&id=2850ae0e&scoped=true"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"

import "./MovieList.vue?vue&type=style&index=0&id=2850ae0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2850ae0e"]])

export default __exports__